import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { StyledText } from './styles';
import * as Sizes from './sizes';
const Text = /*#__PURE__*/forwardRef(({
  as = 'span',
  size,
  weight,
  bold,
  breakWord,
  lineBreak,
  noWrap,
  italic,
  ellipsis = false,
  align,
  color,
  transform,
  marginBottom,
  dotted = false,
  children = null,
  ...props
}, ref) => /*#__PURE__*/React.createElement(StyledText, _extends({
  ref: ref,
  as: as,
  $size: size,
  $weight: weight,
  $bold: bold,
  $breakWord: breakWord,
  $lineBreak: lineBreak,
  $noWrap: noWrap,
  $italic: italic,
  $ellipsis: ellipsis,
  $align: align,
  $color: color,
  $transform: transform,
  $marginBottom: marginBottom,
  $dotted: dotted
}, props), children));
Text.propTypes = {
  as: PropTypes.elementType,
  size: PropTypes.oneOf(Object.values(Sizes)),
  weight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bold: PropTypes.bool,
  breakWord: PropTypes.bool,
  lineBreak: PropTypes.bool,
  noWrap: PropTypes.bool,
  italic: PropTypes.bool,
  ellipsis: PropTypes.bool,
  align: PropTypes.oneOfType([PropTypes.oneOf(['left', 'center', 'right', 'justify']), PropTypes.object]),
  color: PropTypes.string,
  transform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  marginBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  dotted: PropTypes.bool,
  children: PropTypes.node
};
export default Text;
//# sourceMappingURL=Text.js.map